<template>
    <div class="wrap-history">
        <div class="title-page">History Transaction</div>
        <div class="d-flex justify-content-end mb-3">
            <b-button class="btn btn-info mr-1 btn-sm" @click="showFilter">Filter</b-button>
        </div>
        <filter-table-deposit v-if="isShowFilter" @setDataFilter="filterTabel" :dataContract="getDataContract"></filter-table-deposit>
        <table>
            <thead>
                <tr id="top">
                    <th scope="col" style="width: 70px">No</th>
                    <th scope="col">Serial Number</th>
                    <th scope="col">Year</th>
                    <th scope="col" style="width: 120px">owner</th>
                    <th scope="col">Hallmark</th>
                    <th scope="col">Fineness</th>
                    <th scope="col">Weight (gr)</th>
                    <th scope="col" style="width: 200px">Deposit Date</th>
                </tr>
            </thead>
            <tbody v-if="getIsLoading">
                <tr>
                    <td colspan="10">
                        <b-spinner></b-spinner>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(data, i) in dataDeposit" :key="i" v-show="dataDeposit.length != 0">
                    <td data-label="No">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                    <td data-label="Serial Number">{{ data.serial_number }}</td>
                    <td data-label="Year">{{ data.year }}</td>
                    <td data-label="Owner">{{ data.owner }}</td>
                    <td data-label="Hallmark">{{ data.hallmark }}</td>
                    <td data-label="Fineness">{{ data.fineness }}</td>
                    <td data-label="Weight">{{ data.weight }}</td>
                    <td data-label="Deposite Date">{{ data.metal_date | formatDate }}</td>
                </tr>
                <tr v-show="dataDeposit.length == 0">
                    <td colspan="10">No Data Available in Table</td>
                </tr>
            </tbody>
        </table>
        <!-- <div v-if="type == 'offexchange'">
            <list-metal-off :depositDatas="dataDeposit" :pageNumber="currentPage" :totalPerPage="perPage" :totalDeposit="totalData"></list-metal-off>
        </div>
        <div v-else>
            <list-metal :metalData="dataDeposit" :pageNumber="currentPage" :totalPerPage="perPage" :totalData="totalData"></list-metal>
        </div> -->
        <div class="d-flex justify-content-end mt-3">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalData"
                :per-page="perPage"
                @change="handlePageChange"
                aria-controls="new-table"
                first-number
                last-number
                v-show="totalData > 10"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import FilterTableDeposit from "../../utility/filter/FilterTableDeposit.vue";
// import ListMetal from "../../deposit/ListMetal.vue";
// import ListMetalOff from "../../deposit/ListMetalOff.vue";
export default {
    components: {
        FilterTableDeposit,
        // ListMetalOff,
        // ListMetal,
    },
    data() {
        return {
            activity: "deposit",
            startDate: "",
            endDate: "",
            perPage: 10,
            currentPage: 1,
            type: "offexchange",
            owner: "",
            typeInput: "date",
            today: "",
            isShowFilter: false,
            filterData: [],
        };
    },
    computed: {
        dataDeposit() {
            return this.$store.state.bappebtiModule.dataHistories;
        },
        datalistClient() {
            return this.$store.state.bappebtiModule.dataListClient;
        },
        totalData() {
            return this.$store.state.bappebtiModule.totalDataHistories;
        },
        getIsLoading() {
            return this.$store.state.bappebtiModule.isLoading;
        },
        getDataContract() {
            return this.$store.state.vaultModul.dataContract;
        },
    },
    mounted() {
        this.$store.dispatch("getListClient");
        this.$store.dispatch("getContract");
        this.today = new Date().toISOString().split("T")[0];
        // const role = sessionStorage.getItem("role");
        // if (role == 8) {
        //     this.type = "onexchange";
        // } else {
        //     this.type = "offexchange";
        // }
        this.$store.dispatch("getHistoryData", {
            activity: this.activity,
            startDate: this.startDate,
            endDate: this.endDate,
            perPage: this.perPage,
            currentPage: this.currentPage,
            type: this.type,
            owner: this.owner,
        });
    },
    methods: {
        showFilter() {
            this.isShowFilter = !this.isShowFilter;
        },

        filterTypeDeposit(value) {
            this.type = value;
            this.owner = "";
            this.startDate = "";
            this.endDate = "";
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: this.startDate,
                endDate: this.endDate,
                perPage: this.perPage,
                currentPage: this.currentPage,
                type: value,
                owner: this.owner,
            });
        },
        handlePageChange(value) {
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: this.startDate,
                endDate: this.endDate,
                perPage: this.perPage,
                currentPage: value,
                type: this.type,
                owner: this.owner,
            });
        },
        filterTabel(event) {
            console.log(event);
            this.filterData = [this.owner, this.startDate];
            if (this.owner != "") {
                this.filterData.push(this.owner);
            }
            this.$store.dispatch("getHistoryData", {
                activity: this.activity,
                startDate: event.startDate,
                endDate: event.endDate,
                perPage: this.perPage,
                currentPage: this.currentPage,
                type: this.type,
                owner: event.owner,
            });
            this.isShowFilter = false;
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
}

.tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
}

.tab:hover,
.activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
}

.filter {
    margin-bottom: 1rem;
}

.form-group label {
    display: block;
}

.form-group input,
select {
    width: 100%;
    margin-bottom: 0.75rem;
    border: 1px solid #ddd;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;
}

.form-group button {
    width: 100%;
    font-size: 13px !important;
}

.wrap-button {
    display: flex;
    justify-content: end;
    gap: 1rem;
}

.scondary {
    color: var(--clr-scondary);
}
.primary {
    color: var(--success);
}
</style>
